<template>
  <div>
    <div class="gift disFlex fvc vertical">
      <div>
        <div class="disFlex fvc vertical">
          <img src="https://j.weizan.cn/youxiang/check-success.png" class="status-img" />
          <div class="check-status">信息已提交，待审核</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      showqrcode: false,
      showDetail: true,
      amount: "",
      beforeconfirm: true,
    };
  },
  created() {},
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    backpreheat(item) {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.item-box {
  width: 100%;
  padding: 0 15px 15px;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 5px;
  .item-head {
    height: 41px;
    border-bottom: 1px solid #f5f6f7;
    margin-bottom: 15px;
    .item-id {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(105, 105, 105, 1);
    }
    .item-status {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 48, 120, 1);
    }
  }
  .item-left {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    position: relative;
    .item-img {
      width: 100px;
      height: 100px;
      border-radius: 5px;
    }
    .item-data {
      width: 100px;
      height: 22px;
      background: rgba(0, 0, 0, 1);
      opacity: 0.3;
      border-radius: 0 0 5px 5px;
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      .num {
        color: #fcff00;
      }
    }
  }
  .item-right {
    width: 100%;
    margin-left: 10px;
    height: 100px;
    .item-info {
      width: 58.5px;
      height: 33px;
      border-radius: 2px;
    }
    .item-num {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
    }
    .item-title {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
    }
    .price-detail {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 48, 120, 1);
    }
    .options-btn {
      width: 70px;
      height: 24px;
      background: rgba(0, 48, 120, 1);
      border-radius: 12px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 24px;
      text-align: center;
    }
  }
  .tip {
    font-size: 16px;
  }
}
.gift {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding-top: 67px;
  .gift-img {
    width: 116px;
    height: 116px;
    background: rgba(239, 239, 239, 1);
    border: 3px solid rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 28px 12px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    margin: 0 auto 20px;
    .img {
      width: 110px;
      height: 110px;
      border-radius: 12px;
    }
  }
  .gift-qrcode {
    width: 150px;
    height: 150px;
    background: rgba(208, 208, 208, 1);
    margin-top: 102px;
  }
  .btn-box {
    position: fixed;
    bottom: 25px;
    width: 100%;
  }
  .page-btn {
    width: 325px;
    height: 44px;
    background: rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 44px;
    text-align: center;
    margin: 0 auto;
  }
  .back-btn {
    width: 133px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    line-height: 44px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
    text-align: center;
    background: #fff;
  }
  .gift-title {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    text-align: center;
    margin-bottom: 19px;
  }
  .gift-info {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(116, 116, 116, 1);
    text-align: center;
    margin: 0 33px;
  }
  .interact-progress {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    margin: 60px 0 15px;
  }
  .interact-status {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(244, 0, 0, 1);
  }
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-top: 27px;
  }
  .status-img {
    width: 88px;
    height: 88px;
  }
  .check-info {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 24px;
  }
  .check-status {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    text-align: center;
    margin: 20px 0 40px;
  }
  .check-btn {
    width: 215px;
    height: 50px;
    background: rgba(0, 48, 120, 1);
    border-radius: 25px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    margin: 50px 0 28px;
  }
  .record {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }
}
</style>